import { PageContent } from '@core/ui';
import { TableProvider } from '@core/table';

import { useBoxDeclarationsTableContext } from '../hooks';
import { DeclarationsActionBar, FlightDeclarationsTable } from '../containers';

export const BoxDeclarationsPage = () => {
  const { onFetch, context, defaultState } = useBoxDeclarationsTableContext();

  return (
    <TableProvider useCache={false} context={context} defaultState={defaultState} onFetch={onFetch}>
      <PageContent $contain>
        <DeclarationsActionBar />
        <FlightDeclarationsTable />
      </PageContent>
    </TableProvider>
  );
};
